import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, Teleport as _Teleport, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

_pushScopeId("data-v-1fa8b52c")
const _hoisted_1 = { class: "modal-header" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("h1", null, "Select Your Material", -1)
const _hoisted_3 = { id: "modal-materials-container" }
const _hoisted_4 = ["id"]
const _hoisted_5 = ["id", "onInput"]
const _hoisted_6 = ["id", "onInput"]
const _hoisted_7 = ["for"]
const _hoisted_8 = ["src", "alt"]
const _hoisted_9 = { class: "material-info" }
const _hoisted_10 = ["innerHTML"]
_popScopeId()

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_CloseSVG = _resolveComponent("CloseSVG")!

  return (_openBlock(), _createBlock(_Teleport, { to: "body" }, [
    _createElementVNode("div", {
      class: _normalizeClass([_ctx.fadeTransition, "modal"])
    }, [
      _createElementVNode("div", {
        class: _normalizeClass(["modal-body", _ctx.bounceTransition])
      }, [
        _createElementVNode("div", _hoisted_1, [
          _hoisted_2,
          _createElementVNode("div", {
            class: "close-svg",
            onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.closeModal && _ctx.closeModal(...args)))
          }, [
            _createVNode(_component_CloseSVG, { propId: 'materials-modal-close' })
          ])
        ]),
        _createElementVNode("div", _hoisted_3, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.materials, (material) => {
            return (_openBlock(), _createElementBlock("div", {
              class: "modal-materials",
              key: material.id,
              id: material.id
            }, [
              (Number(material.id) === _ctx.currentLabelMaterialId)
                ? (_openBlock(), _createElementBlock("input", {
                    key: 0,
                    checked: "",
                    name: "labelMaterialInput",
                    type: "radio",
                    id: material.image_id,
                    onInput: ($event: any) => (_ctx.handleInput(material))
                  }, null, 40, _hoisted_5))
                : (_openBlock(), _createElementBlock("input", {
                    key: 1,
                    name: "labelMaterialInput",
                    type: "radio",
                    id: material.image_id,
                    onInput: ($event: any) => (_ctx.handleInput(material))
                  }, null, 40, _hoisted_6)),
              _createElementVNode("label", {
                for: material.image_id,
                class: "material-option"
              }, [
                (material.image_id)
                  ? (_openBlock(), _createElementBlock("img", {
                      key: 0,
                      src: material.image_url,
                      alt: material.title
                    }, null, 8, _hoisted_8))
                  : _createCommentVNode("", true),
                _createElementVNode("div", _hoisted_9, [
                  _createElementVNode("p", null, _toDisplayString(material.title), 1),
                  _createElementVNode("div", {
                    innerHTML: material.popup_description
                  }, null, 8, _hoisted_10)
                ])
              ], 8, _hoisted_7)
            ], 8, _hoisted_4))
          }), 128))
        ]),
        _createElementVNode("button", {
          "aria-label": "Open change label material modal",
          class: "modal-select-btn",
          onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.changeMaterial()))
        }, " Change Material ")
      ], 2)
    ], 2)
  ]))
}